module.exports = __webpack_public_path__ + "img/arrow-left.b176f612.svg";